import React from 'react'

export default function ProgressLoad({ progress }) {
    return (
        <div className='w-full h-full flex-center'>
            <div className="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-400">
                <div className="bg-blue-600 h-4 rounded-full" style={{ width: `${progress}%` }}></div>
            </div>
        </div>
    )
}
